import getStore from '../store';
import type { ProjectId } from '../schema';

export default function isSelectedProject(id: ProjectId): boolean {
    return getStore().selectedProjectId === id;
}
